<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Payment Advice</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="table-responsive" style="min-height: 400px;">
                      <table class="table table-bordered">
                        <thead>
                        <tr>
                          <th>Payment Category</th>
                          <th>Net Payable</th>
                          <th>Paid Amount</th>
                          <th>Due Amount</th>
                          <th class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in payrollAdviceSummaryData" :key="i">
                          <td>{{ item.payment_mode_name }}</td>
                          <td class="text-right">{{ item.total_payable_amount }}</td>
                          <td class="text-right">{{ item.total_paid_amount }}</td>
                          <td class="text-right">{{ item.total_due_amount }}</td>
                          <td>
                            <button v-if="item.total_due_amount > 0" class="btn btn-primary btn-sm me-1"
                                    @click="goToShow(item, 'payroll-advice')"
                                    style="cursor: pointer"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <button class="btn btn-success btn-sm me-1"
                                    @click="goToShow(item, 'payroll-advice-list')"
                                    style="cursor: pointer"
                            >
                              <i class="fas fa-pencil-alt"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import {useRoute, useRouter} from 'vue-router';

const props = defineProps({
  payrollAdviceSummaryData:{
    type:Object,
    default:{}
  },
});
const emit = defineEmits(['submitted']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const route = useRoute();
const router = useRouter();

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

const goToShow = (item, routeName = 'payroll-advice') => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
    payrollStatementId:item.payroll_statement_id,
    paymentModeId:item.payment_mode_id
  }

  onClickClose()

  let query = route.query;

  router.push({
    name:  routeName,
    params: param,
    query: query
  })
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

onMounted(() => {
})
</script>
